import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { LanguageService } from 'projects/shared/lib/services/infrastructure/language/language.service';
import { ENVIRONMENT } from '../environment/environment';


// eslint-disable-next-line @typescript-eslint/naming-convention
export const httpLangInterceptor: HttpInterceptorFn = (req, next) => {
  let lang = inject(LanguageService);

  let targetUrlIsInBlacklistResult = targetUrlIsInBlacklist(req.url);
  if (targetUrlIsInBlacklistResult == true) {
    return next(req);
  }

  let currentLocale = lang.currentLocaleGetOrDefault();

  if (currentLocale) {
    let modifiedRequest = req.clone({
      headers: req.headers.set('Language', currentLocale.code),
    });
    return next(modifiedRequest);
  } else {
    return next(req);
  }
};

function targetUrlIsInBlacklist(url: string) {
  let blacklist = ENVIRONMENT.locale.languageHttpHeaderBlacklist;

  if (blacklist == undefined) {
    return false;
  }

  return blacklist.some(b => url.includes(b));
}
